<template>
  <v-container
    id="groupSummaryDetailFields"
  >
    <v-row>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.broker"
          label="Broker"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.groupName"
          label="Group"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.brokerGroupYear"
          label="Year"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.sicCode"
          label="SIC Code"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.planYearStartDate"
          label="Plan Start"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.planYearEndDate"
          label="Plan End"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.selfService"
          label="Self Service"
          data-type="boolean"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.multiYear"
          label="Multi Year"
          data-type="boolean"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.oeStartDate"
          label="OE Start"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.oeEndDate"
          label="OE End"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.selerixCloseDate"
          label="Benefit Admin Close"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.oeFileSendDate"
          label="OE File Send"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="!openEnrollment.uploadOrPayrollFile"
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.uploadOrPayrollFile"
          label="Payroll File"
          data-type="boolean"
        />
      </v-col>
      <v-col
        v-if="openEnrollment.uploadOrPayrollFile"
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.uploadOrPayrollFileDesc"
          label="Payroll File Type"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.payrollDeadlineToBroker"
          label="Payroll Deadline Broker"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-date
          v-model="openEnrollment.payrollDeadlineToGroup"
          label="Payroll Deadline Group"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.uploadAssignedName"
          label="Upload Assigned"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.platform"
          label="Platform"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.benefitAdminSite"
          label="Benefit Admin Site"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <base-display-value
          v-model="openEnrollment.siteUrl"
          label="Site URL"
          data-type="url"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'GroupSummaryDetailFields',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
    },
  }
</script>
